import { Component, Injector, Input, OnInit } from '@angular/core';
import { ListenerBase } from '../listener-base';
import { MenuItem } from 'src/app/app.component';
import { Unidade } from 'src/app/models/unidade.model';
import { UnidadeDaoService } from 'src/app/dao/unidade-dao.service';
import { IIndexable } from 'src/app/models/base.model';
import { ListenerAllPagesService } from '../listener-all-pages.service';
import { UnidadeService } from 'src/app/modules/uteis/services/unidade.service';

declare global {
  interface Window {
      _shouldBeModal: boolean;
  }
}

@Component({
  selector: 'petrvs-app-sei',
  templateUrl: './petrvs-app-sei.component.html',
  styleUrls: ['./petrvs-app-sei.component.scss']
})
export class PetrvsAppSeiComponent extends ListenerBase implements OnInit {
  @Input() contexto?: any[];
  @Input() set menu(value: MenuItem[] | undefined) {
    if(this._menuJson != JSON.stringify(value)) {
      this._menuJson = JSON.stringify(value);
      this._menu = value;
      this.execute<void>("carregarMenuLateral", [this._menu]);
    }
  }
  get menu(): MenuItem[] | undefined {
    return this._menu;
  }
  @Input() set hora(value: string | undefined) {
    if(this._hora != value) {
      this._hora = value;
      this.execute<void>("atualizarHora", [this._hora]);
    }
  }
  get hora(): string | undefined {
    return this._hora;
  }
  @Input() set notificacao(value: number) {
    if(this._notificacao != value) {
      this._notificacao = value;
      this.execute<void>("atualizarNotificacao", [this._notificacao]);
    }
  }
  get notificacao(): number {
    return this._notificacao;
  }
  @Input() set ocultarMenu(value: boolean) {
    if(this._ocultarMenu != value) {
      this._ocultarMenu = value;
      this.execute<void>("visibilidadeMenuSei", [!this._ocultarMenu]);
    }    
  }
  get ocultarMenu(): boolean {
    return this._ocultarMenu;
  }
  @Input() set unidades(value: Unidade[] | undefined) {
    if(this._unidades != value) {
      this._unidades = value;      
      this.carregarPerfil();
    }
  }
  get unidades(): Unidade[] | undefined {
    return this._unidades;
  }
  @Input() set unidade(value: Unidade | undefined) {
    if(this._unidade != value) {
      this._unidade = value;
      this.carregarPerfil();
    }
  }
  get unidade(): Unidade | undefined {
    return this._unidade;
  }
  get shouldBeModal(): boolean {
    return window._shouldBeModal ?? true;
  }

  public unidadeService: UnidadeService;
  public allPages: ListenerAllPagesService;

  private _menu?: MenuItem[];
  private _menuJson?: string;
  private _hora?: string;
  private _notificacao: number = 0;
  private _unidade?: Unidade;
  private _unidades?: Unidade[];
  private _ocultarMenu: boolean = false;

  constructor(public injector: Injector) {
    super(injector, "petrvs-app-sei");
    this.allPages = injector.get<ListenerAllPagesService>(ListenerAllPagesService);
    this.unidadeService = injector.get<UnidadeService>(UnidadeService);
  }

  ngDoCheck() {
    if(JSON.stringify(this._menu) != this._menuJson) this.menu = this._menu;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  public async carregarPerfil() {
    if(this._unidade && this._unidades && this.auth.usuario) {
      let opcoes: IIndexable[] = [
        { action: "PERFIL", icon: "bi bi-person-circle", label: "Perfil" },
        { action: "PREFERENCIAS", icon: "bi bi-gear", label: "Preferências" }
      ];
      if(this.unidadeService.isGestorUnidade(this.auth.unidade, true)) {
        opcoes.push({ action: "UNIDADE", icon: this.entityService.getIcon("Unidade"), label: "Unidade" });
        opcoes.push({ action: "INTEGRANTES", icon: "bi bi-people", label: "Integrantes" });
      }
      if(this.gb.isSeiModule) {
        opcoes.push({ separator: true });
        opcoes.push({ action: "DESABILITAR", icon: "bi bi-x-circle", label: "Desabilitar" });
      }
      let hasContexto = this.gb.auth.hasPermissionTo('MOD_CTXT') || this.gb.auth.hasPermissionTo('CTXT_DEV');
      let contexto = this.contexto?.filter(x => hasContexto && (!x.permition?.length || this.auth.hasPermissionTo(x.permition)));
      let perfil = {
        id: this.auth.usuario.id,
        name: this.auth.usuario.nome,
        apelido: this.auth.usuario.apelido,
        url_foto: this.gb.getAbsolutePath(this.auth.usuario.url_foto || "/assets/images/profile.png"),
        unidade_id: this._unidade.id,
        opcoes: opcoes,
        contexto: contexto,
        contexto_id: this.gb.contexto?.id,
        unidades: this._unidades.map(x => Object.assign({}, {
          id: x.id,
          sigla: x.sigla,
          atribuicoes: this.auth.usuario?.areas_trabalho?.find(y => y.unidade_id == x.id)?.atribuicoes.map(z => z.atribuicao) || []
        })),
      }
      await this.execute<void>("carregarPerfil", [perfil]);
    }
  }

  public async carregarMenuLateral() {
    await this.execute<void>("carregarMenuLateral", [this._menu]);
  }
 
  public async menuLateralButtonClick(action: string) {
    let self = this;
    let modal = this.shouldBeModal;
    let item = this.gb.app!.modulo.reduce((a: MenuItem | undefined, v) => a = a || (v.permition == action ? v : v.menu?.find(x => typeof x == "string" ? false : x.permition == action) as MenuItem), undefined);
    if(item?.route) this.go.navigate({ route: item.route, params: item.params }, Object.assign(item.metadata || {}, { root: true, modal: modal }));
  }

  public async selecionarUnidade(id: string) {
    this.gb.app!.selecionaUnidade(id);
  }

  public async selecionarContexto(id: string) {
    this.gb.setContexto(id);
    this.carregarPerfil();
    this.execute<void>("atualizarHora", [this._hora]);
  }

  public async desabilitarModulo() {
    const confirm = await this.dialog.confirm("Desabilitar módulo?", "Deseja realmente desabilitar o módulo do Petrvs?\nApós desabilitar, você poderá reabilitar acessando o Petrvs e desmarcando a opção Preferências > Desabilitar módulo SEI");
    if(confirm) {
      await this.auth.updateUsuarioConfig(this.auth.usuario!.id, { desabilitar_modulo_sei: true });
      await this.allPages.ajax("remover_sessao_usuario");
      await this.execute<void>("recarregarPagina", []);
    }
  }

  public async perfilButtonClick(action: string) {
    switch(action) {
      case "SUPORTE": this.go.navigate({ route: ['suporte'] }, { root: true, modal: true }); break;
      case "NOTIFICACAO": this.go.navigate({ route: ['uteis', 'notificacoes'] }, { root: true, modal: true }); break;
      case "PERFIL": this.go.navigate({ route: ['configuracoes', 'usuario', this.auth.usuario!.id, 'edit'] }, { root: true, modal: true }); break;
      case "PREFERENCIAS": this.go.navigate({ route: ['configuracoes', 'preferencia', 'usuario', this.auth.usuario!.id] }, { root: true, modal: true }); break;
      case "UNIDADE": this.go.navigate({ route: ['configuracoes', 'unidade', this.auth.unidade!.id, 'edit'] },{ root: true, modal: true }); break;
      case "INTEGRANTES": this.go.navigate({ route: ['configuracoes', 'unidade', '', this.auth.unidade!.id, 'integrante'] }, { metadata: { unidade: this.auth.unidade } }); break;
      case "TUTORIAIS": this.go.navigate({route: ['suporte', 'ajuda', '']}); break;
      case "DESABILITAR": await this.desabilitarModulo(); break;
    }
  }
}
